import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { BaseLocationFragment, FullJobFragment } from '../../../generated/graphql.generated';
import { JOB_LOCATION_TYPES_V3 } from '../../global.constants';
import { showGoogleMapsRoute, viewLocationOnGoogleMaps } from '../../utilities/locations.util';

@Component({
  selector: 'app-job-locations',
  templateUrl: './job-locations.component.html',
  styleUrls: ['./job-locations.component.scss']
})
export class JobLocationsComponent implements OnInit, OnChanges {

  @Input() job: FullJobFragment;

  // Set to true to see the 'View Route' button
  @Input() showRoute = false;

  // If True will show all locations on the job, even if they are not in showLocationTypes
  @Input() showAll = false;

  // Shows these locations even if they are not set
  @Input() showLocationTypes: string[] = ['dock', 'start', 'end'];

  locationsToShow: FullJobFragment['locations'];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.locationsToShow = this.getLocationsToShow();
  }

  getLocationsToShow() {
    const allLocations = this.job?.locations;
    if (!allLocations) { return allLocations; }

    const filtered = this.showAll
      ? allLocations.slice()
      : allLocations.filter((l) => this.showLocationTypes.includes(l.locationType));

    return filtered.slice().sort((a, b) => {
      const indexOfA = JOB_LOCATION_TYPES_V3.indexOf(a.locationType);
      const indexOfB = JOB_LOCATION_TYPES_V3.indexOf(b.locationType);

      const sortValueOfA = indexOfA === -1 ? Number.MAX_SAFE_INTEGER : indexOfA;
      const sortValueOfB = indexOfB === -1 ? Number.MAX_SAFE_INTEGER : indexOfB;

      if (sortValueOfA !== sortValueOfB) { return sortValueOfA - sortValueOfB; }

      return allLocations.indexOf(a) - allLocations.indexOf(b);
    });
  }

  viewLocationOnGoogleMaps(location: BaseLocationFragment) {
    return viewLocationOnGoogleMaps(location);
  }

  showGoogleMapsRoute(){
    return showGoogleMapsRoute(this.job);
  }
}
